/**
 * Error Pages - 404 and Error Boundary
 */
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Home, AlertTriangle, RefreshCw } from '../lib/icons';

// 404 Not Found Page
export const NotFoundPage = () => {
  const navigate = useNavigate();
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-theme-bg-alt to-white flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        <div className="text-8xl font-light text-theme-muted mb-4">404</div>
        <h1 className="text-2xl font-bold text-theme-text mb-2">Page introuvable</h1>
        <p className="text-theme-primary mb-8">
          La page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <Button onClick={() => navigate('/')} className="gap-2">
          <Home className="w-4 h-4" />
          Retour à l'accueil
        </Button>
      </div>
    </div>
  );
};

// Error Page (for caught errors)
export const ErrorPage = ({ error, resetError }) => {
  const handleGoHome = () => {
    resetError?.();
    window.location.href = '/';
  };
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-red-50 to-white flex items-center justify-center p-6">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 bg-theme-error-light rounded-full flex items-center justify-center mx-auto mb-4">
          <AlertTriangle className="w-8 h-8 text-theme-error" />
        </div>
        <h1 className="text-2xl font-bold text-theme-text mb-2">Une erreur est survenue</h1>
        <p className="text-theme-text mb-4">
          Nous sommes désolés, quelque chose s'est mal passé.
        </p>
        {error?.message && (
          <pre className="bg-theme-bg-alt p-3 rounded-lg text-xs text-left text-theme-text mb-6 overflow-auto max-h-32">
            {error.message}
          </pre>
        )}
        <div className="flex gap-3 justify-center">
          <Button variant="outline" onClick={() => window.location.reload()} className="gap-2">
            <RefreshCw className="w-4 h-4" />
            Réessayer
          </Button>
          <Button onClick={handleGoHome} className="gap-2">
            <Home className="w-4 h-4" />
            Accueil
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
